Ext.define('SA.view.scatterplot.ScatterPlotMessageOverlay', {
    alias: 'widget.scatter-plot-message-overlay',
    extend: 'Ext.Component',

    cls: 'sa-scatter-plot-message-overlay',
    hidden: true,

    cannotResolveGeoReleaseForBothAttributesAndLocationTpl: [
        'Neither data variable is available for your location ({[this.renderLocation(values.location)]}).'
    ],

    cannotResolveGeoReleaseForOneAttributeAndLocationTpl: [
        'The {[this.renderAttribute(values.attribute)]} data variable is not available for ',
        'your location ({[this.renderLocation(values.location)]}).'
    ],

    cannotResolveGeoUnitForAttributesHtml: [
        'There is no common geographic unit among the data variables selected for this scatter plot.'
    ],

    cannotResolveGeoUnitForBothAttributesAndLocationTpl: [
        'Neither data variable is available for your location ({[this.renderLocation(values.location)]}). ',
        'They are available for the {[this.renderGeoUnitsList(values.geoUnits)]}.'
    ],

    cannotResolveGeoUnitForOneAttributeAndLocationTpl: [
        'The {[this.renderAttribute(values.attribute)]} data variable is not available for your location ({[this.renderLocation(values.location)]}). ',
        'It is available for the {[this.renderGeoUnitsList(values.geoUnits)]}.'
    ],

    tplConfig: {
        renderAttribute(attribute) {
            return this.strong(this.singleQuote(Ext.String.htmlEncode(SA.data.AttributesCache.getLabel(attribute))));
        },

        renderGeoUnitsList(units) {
            var mapUnit = unit => this.strong(this.singleQuote(Ext.String.htmlEncode(SA.data.GeographicUnits.get(unit).name)));

            return Ext.util.Format.commaList(units.map(mapUnit), 'and', 'geographic unit');
        },

        renderLocation(location) {
            return this.strong(this.singleQuote(Ext.util.Format.locationRenderer(SA.data.LocationsCache.get(location))));
        },

        singleQuote(html) {
            return `‘${html}’`;
        },

        strong(html) {
            return `<strong>${html}</strong>`;
        }
    },

    refresh(model) {
        var applyTpl = (tpl, values) => new Ext.XTemplate(tpl.join(''), this.tplConfig).apply(values),
            attributes = model.getAttributes(),
            location = model.getLocation(),
            html = null;

        if (!model.canResolveGeographicRelease()) {
            let unavailable = attributes.filter(attribute => !SA.data.DataModel.canResolveGeographicRelease({attribute, location}));

            if (unavailable.length === 1) {
                html = applyTpl(this.cannotResolveGeoReleaseForOneAttributeAndLocationTpl, {attribute: unavailable[0], location});
            }
            else {
                html = applyTpl(this.cannotResolveGeoReleaseForBothAttributesAndLocationTpl, {location});
            }
        }
        else if (!SA.data.AttributesCache.canResolveGeographicUnit({attributes})) {
            html = this.cannotResolveGeoUnitForAttributesHtml;
        }
        else if (!model.canResolveGeographicUnit()) {
            let unavailable = attributes.filter(attribute => !SA.data.DataModel.canResolveGeographicUnit({attribute, location})),
                geoUnits = SA.data.GeographicUnits.getAllowedIdsForAttributes(attributes);

            if (unavailable.length === 1) {
                html = applyTpl(this.cannotResolveGeoUnitForOneAttributeAndLocationTpl, {attribute: unavailable[0], geoUnits, location});
            }
            else {
                html = applyTpl(this.cannotResolveGeoUnitForBothAttributesAndLocationTpl, {geoUnits, location});
            }
        }

        this.update(html ?? '');
        this.setVisible(html !== null);
    }
});